import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';

export default function ContractsIndex() {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1">
        <Topbar user={{ name: 'Mateus Teixeira', role: 'Administrador' }} />
        <main className="mx-auto max-w-7xl p-6">
          <div className="mb-6 flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold text-gray-800">Contratos</h2>
              <p className="mt-2 text-sm text-gray-500">Gerencie e acompanhe todos os seus contratos.</p>
            </div>
          </div>

          <div className="rounded-2xl border border-dashed border-gray-300 bg-white px-6 py-16 text-center">
            <h3 className="text-lg font-medium text-gray-800">Nenhum contrato encontrado.</h3>
            <p className="mt-2 text-sm text-gray-500">Os contratos gerados a partir dos orçamentos aparecerão aqui.</p>
            <Link to="/system/proposals" className="mt-6 inline-flex rounded-2xl bg-purple-600 px-4 py-2 text-sm text-white hover:bg-purple-700">
              Ver orçamentos
            </Link>
          </div>
        </main>
      </div>
    </div>
  );
}
